import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { orderBy, reduce } from 'lodash'
import moment from 'moment'
import DtoDetailPiezometerMeasure from '../../dto/DtoDetailPiezometerMeasure'
import { getAverage } from '../../../utils/MathUtil'
import { Bar, IChart } from 'react-aquasys'
import i18n from 'simple-react-i18n'

class AverageLevelChartPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			width: 0
		}
	}

	getChart = () => {
		const measureByYear = reduce(this.props.piezometerMeasures, (result, value) => {
			let yearMeasure = moment(value.date).year();
			(result[yearMeasure] || (result[yearMeasure] = [])).push(value.measure)
			return result
		}, {})
		const actualYear = moment().year()
		const averageMeasureByYear = Object.keys(measureByYear).map((measures) => {
			const result = {
				x: measures,
				y: getAverage(measureByYear[measures])
			}
			if (measures == actualYear) {
				result.color = 'red'
			}
			return result
		})
		const data = orderBy(averageMeasureByYear, ['y'], ['desc'])
		const serie = [new Bar({ data: data, color: 'blue', name: 'test' })]

		return (
			<IChart height='200' series={ serie }/>
		)
	}

	render() {
		return (
			<div className='col s12 m12 l12 no-margin no-padding white-background' ref='historyChart'>
				<div className='col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding'>
					{ i18n.annualAverageLevels }
				</div>
				<div className='col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding'>
					{ this.getChart() }
				</div>
			</div>
		)
	}

	componentDidMount() {
		this.setState({ width: this.refs.historyChart.offsetWidth })
	}
}

AverageLevelChartPanel.propTypes = {
	piezometerMeasures: PropTypes.arrayOf(PropTypes.instanceOf(DtoDetailPiezometerMeasure))
}

AverageLevelChartPanel.defaultProps = {
	piezometerMeasures: []
}

export default AverageLevelChartPanel



// WEBPACK FOOTER //
// ./src/station/components/piezometer/AverageLevelChartPanel.js